function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bones") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "puruluu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bone_1",
    "data-name": "bone 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.63,
    y: 475.3,
    width: 89.68,
    height: 371.82,
    transform: "translate(-364.1 435.66) rotate(-44.65)",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4,442.4l-7.09,66.88c-3.46,32.66-32.9,45-51,30.24-5.08-4.13-9.26-10.42-11.73-19L137,463.05l-1.41-4.88a45,45,0,0,1-1.33-6.28c-3.14-22,9.63-44.42,28.63-47.84l25-4.49C208.74,395.83,226.11,416.8,223.4,442.4Z",
    style: {
      fill: "#ddc2a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.22,567.17l78.63-15.46c38.4-7.55,48.8-49.64,28.62-73.64-5.66-6.75-13.76-12.05-24.31-14.78L155.29,445l-6-1.55a47.45,47.45,0,0,0-7.67-1.34c-26.7-2.54-51.51,17.14-52.83,43.92L87.05,521.3C85.63,550.62,113.13,573.09,143.22,567.17Z",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.88,513.8,204.51,580c-32.89,32.32-75.8,19.4-82.27-12.73-1.82-9-.75-19.56,4.21-31l33.34-77.11,2.83-6.55a62.24,62.24,0,0,1,4.16-8C183,417.87,216.85,405,240.5,418.25l31.16,17.47C297.54,450.24,297.65,488.47,271.88,513.8Z",
    style: {
      fill: "#ebdbc7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.29,867.49l7.09-66.89c3.46-32.66,32.9-45,51-30.23,5.08,4.13,9.26,10.41,11.73,19l16.57,57.49,1.41,4.89a44.91,44.91,0,0,1,1.33,6.27c3.15,22-9.63,44.42-28.63,47.84l-25,4.5C478,914.06,460.58,893.08,463.29,867.49Z",
    style: {
      fill: "#ddc2a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.48,742.71l-78.64,15.46c-38.4,7.55-48.8,49.64-28.62,73.65,5.66,6.74,13.76,12,24.31,14.78l70.87,18.3,6,1.56a47.11,47.11,0,0,0,7.66,1.33c26.7,2.55,51.51-17.13,52.83-43.91l1.72-35.29C601.06,759.26,573.56,736.79,543.48,742.71Z",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.81,796.09l67.37-66.2c32.89-32.31,75.8-19.4,82.27,12.73,1.83,9,.75,19.56-4.21,31l-33.34,77.1-2.83,6.56a62.19,62.19,0,0,1-4.15,8c-16.26,26.69-50.08,39.56-73.73,26.32L415,874.17C389.15,859.65,389,821.41,414.81,796.09Z",
    style: {
      fill: "#ebdbc7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bone_1-2",
    "data-name": "bone 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.47,
    y: 61.49,
    width: 43.21,
    height: 179.15,
    transform: "translate(345.86 690.15) rotate(-83.42)",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,112.56l17.52,27.26c8.55,13.32,1.21,26.83-10,26.75A17.89,17.89,0,0,1,493.38,163l-23.57-16.59-2-1.41a21.68,21.68,0,0,1-2.39-2c-7.83-7.32-9.79-19.59-3.69-26.61l8-9.24C476.47,99.49,489.32,102.13,496,112.56Z",
    style: {
      fill: "#ddc2a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.56,183.63l24.87-29.54c12.15-14.42,3.35-33.37-11.47-36.3a22.28,22.28,0,0,0-13.59,1.79l-32.14,14.51-2.74,1.23a22.56,22.56,0,0,0-3.28,1.81c-10.8,7.1-14.18,22-6.59,32.44l10,13.77C476.94,194.79,494.05,194.93,503.56,183.63Z",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.78,124.75l-5.33,45.19c-2.6,22.07-22.62,30.17-34.74,20.05-3.4-2.84-6.18-7.12-7.79-12.93l-10.74-39-.91-3.32a28.93,28.93,0,0,1-.85-4.26c-2-14.93,6.87-30,19.75-32.13l17-2.84C526.24,93.14,537.82,107.46,535.78,124.75Z",
    style: {
      fill: "#ebdbc7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.45,193.89l-17.52-27.26c-8.56-13.31-1.22-26.82,10-26.75a17.87,17.87,0,0,1,10.13,3.59l23.57,16.6,2,1.41a21.6,21.6,0,0,1,2.39,2c7.83,7.33,9.79,19.59,3.68,26.61l-8,9.24C685,207,672.15,204.32,665.45,193.89Z",
    style: {
      fill: "#ddc2a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.91,122.83,633,152.37c-12.14,14.42-3.35,33.36,11.48,36.29a22.2,22.2,0,0,0,13.59-1.78l32.14-14.51,2.73-1.23a22.5,22.5,0,0,0,3.28-1.82c10.8-7.1,14.18-22,6.6-32.43l-10-13.78C684.54,111.67,667.43,111.53,657.91,122.83Z",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.69,181.7,631,136.51c2.61-22.06,22.62-30.16,34.75-20,3.4,2.83,6.18,7.12,7.78,12.93l10.75,39,.91,3.32a30.45,30.45,0,0,1,.85,4.25c2,14.93-6.87,30-19.75,32.14l-17,2.83C635.23,213.32,623.65,199,625.69,181.7Z",
    style: {
      fill: "#ebdbc7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bone2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M885.61,444.33,825,439.62c-29.59-2.3-45.75,26.33-35.89,48a35,35,0,0,0,14.74,15.75l48.06,27.8,4.09,2.36a35.42,35.42,0,0,0,5.33,2.53c19,7.3,41.12-2,47.53-21.33l8.44-25.43C924.31,468.14,908.79,446.13,885.61,444.33Z",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.48,600.38,530,591.09c25.15-4.53,31-39.86,17.12-61.3A35.3,35.3,0,0,0,530.74,516l-47.22-19.09-4-1.62a27.42,27.42,0,0,0-5.09-1.51c-17.68-3.49-33.59,12-33.82,34.79l-.29,30C440.08,583.44,458.76,603.93,478.48,600.38Z",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 645.04,
    y: 347.41,
    width: 77.16,
    height: 319.92,
    transform: "translate(438.78 1322.73) rotate(-109.87)",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776,370.18l-6.16,68.68c-3,33.54,35.15,52.83,64,42.33A43,43,0,0,0,854.68,465l36.93-53.68,3.13-4.56a37.15,37.15,0,0,0,3.37-6c9.68-21.34-2.78-46.78-28.49-54.69l-33.88-10.41C807.59,327,778.31,343.9,776,370.18Z",
    style: {
      fill: "#e4ceb4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.44,636.16l8-62.17c3.91-30.36-21.49-48.07-42-38.75-5.77,2.62-11.16,7.38-15.41,14.59l-28.53,48.4-2.43,4.11a40.81,40.81,0,0,0-2.66,5.39c-7.88,19.26-.62,42.38,16.77,49.71l22.93,9.64C543.14,675.09,564.37,660,567.44,636.16Z",
    style: {
      fill: "#e4ceb4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "184.42 200.61 184.69 200.96 184.89 201.21 184.9 201.23 203.06 224.34 218.53 244.01 219.11 244.75 199.99 290.15 197.47 296.14 197.41 296.28 197.53 296.19 197.91 295.89 241.23 261.84 241.41 261.69 241.51 261.61 290.47 282.24 293.2 283.39 291.45 281.17 259.67 240.73 259.61 240.65 258.54 239.29 280.2 187.86 280.31 187.6 259.08 204.29 236.07 222.38 235.91 222.31 184.42 200.61",
    style: {
      fill: "#ebdbc7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.26 331.92 468.23 331.9 280.62 187.54 235.72 222.45 424.34 366.39 424.64 366.62 446.13 383.03 453.03 368.07 468.26 331.92",
    style: {
      fill: "#bfa588"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.47 296.14 197.53 296.19 385.41 440.44 385.46 440.47 390.41 436.58 408.55 391.71 408.61 391.56 408.83 391.02 407.83 390.25 406.86 389.51 241.41 261.69 218.97 244.35 218.53 244.01 219.11 244.75 199.99 290.15 197.47 296.14",
    style: {
      fill: "#ab8f6d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.39 200.83 219.4 244.9 408.83 391.93 384 350.62 184.39 200.83",
    style: {
      fill: "#bfa588"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.72 222.45 184.39 200.83 372.36 345.09 425.35 366.92 235.72 222.45",
    style: {
      fill: "#ab8f6d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.41 440.44 385.37 440.54 385.46 440.47 390.41 436.58 429.48 405.87 481.17 427.65 446.51 383.55 468.28 331.85 424.04 366.63 372.39 344.86 407.08 389.01 406.86 389.51 385.41 440.44",
    style: {
      fill: "#ebdbc7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.94 268.26 471.23 268.45 471.44 268.58 471.45 268.59 490.29 280.65 506.34 290.91 506.94 291.3 504.56 328.72 504.25 333.66 504.25 333.77 504.31 333.68 504.51 333.37 527.12 298.04 527.21 297.89 527.26 297.81 567.62 300.37 569.87 300.51 568.06 299.36 535.08 278.25 535.02 278.21 533.91 277.5 536.6 235.11 536.61 234.89 525.53 252.21 513.52 270.97 513.39 270.96 470.94 268.26",
    style: {
      fill: "#ebdbc7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "707.84 291.54 707.81 291.53 536.81 234.78 513.29 271.11 684.91 327.32 685.18 327.41 704.74 333.81 705.95 321.33 707.84 291.54",
    style: {
      fill: "#bfa588"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "504.25 333.66 504.31 333.68 675.48 390.29 675.52 390.3 678.11 386.26 679.9 349.47 679.91 349.35 679.93 348.91 679.02 348.6 678.14 348.31 527.21 297.89 506.74 291.05 506.34 290.91 506.94 291.3 504.56 328.72 504.25 333.66",
    style: {
      fill: "#ab8f6d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470.98 268.43 507.18 291.33 680.16 349.55 651.97 326.08 470.98 268.43",
    style: {
      fill: "#bfa588"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.29 271.11 470.98 268.43 642.21 325.03 685.77 327.44 513.29 271.11",
    style: {
      fill: "#ab8f6d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "675.48 390.29 675.48 390.37 675.52 390.3 678.11 386.26 698.49 354.4 741.1 357.11 705.14 334.09 707.84 291.49 684.75 327.57 642.18 324.86 678.17 347.89 678.14 348.31 675.48 390.29",
    style: {
      fill: "#ebdbc7"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBones);
export default __webpack_public_path__ + "static/media/bones.0ab47a0e07b7ac277925ebb7843ed84f.svg";
export { ForwardRef as ReactComponent };